import type { CustomTheme } from '../../../types/custom-theme';
import type { Product } from '../../../types/product';

const base: CustomTheme.CSSProperties = {
  padding: 's16',
  flex: '0 1 100%',
  maxWidth: '100%',
};

const chart = {
  default: {
    ...base,
    backgroundColor: 'indigo.100',
    color: 'white',
  },
  inverse: {
    ...base,
    backgroundColor: 'white',
    color: 'coolGrey.100',
  },
  transparent: {
    ...base,
    background: 'transparent',
  },
};

const co = {
  default: {
    ...base,
    backgroundColor: 'indigo.100',
    color: 'white',
  },
  inverse: {
    ...base,
    backgroundColor: 'white',
    color: 'coolGrey.100',
  },
  transparent: {
    ...base,
    background: 'transparent',
  },
};

const edu = {
  default: {
    ...base,
    backgroundColor: 'indigo.100',
    color: 'white',
  },
  inverse: {
    ...base,
    backgroundColor: 'white',
    color: 'coolGrey.100',
  },
  transparent: {
    ...base,
    background: 'transparent',
  },
};

const scale = {
  default: {
    ...base,
    backgroundColor: 'indigo.90',
    color: 'white',
  },
  inverse: {
    ...base,
    backgroundColor: 'white',
    color: 'coolGrey.100',
  },
  transparent: {
    ...base,
    background: 'transparent',
  },
};

const spark = {
  default: {
    ...base,
    backgroundColor: 'indigo.90',
    color: 'white',
  },
  inverse: {
    ...base,
    backgroundColor: 'white',
    color: 'coolGrey.100',
  },
  transparent: {
    ...base,
    background: 'transparent',
  },
};

const panel: Product.VariantKeyModes<PanelVariantsType> = {
  products: {
    chart,
    chartblog: chart,
    co,
    edu,
    scale,
    spark,
  },
};

export type PanelVariantsType = 'default' | 'inverse' | 'transparent';
export const panelVariants = Object.keys(chart) as PanelVariantsType[];

export default panel;
